export enum ErrorCodes {
  /* Network errors */
  API_NO_RESPONSE = 1000, // This is the case where the Video API has a connection issue or times out and we recieve no response or error message
  INVALID_VIDEO_GUID = 1001, // This is the case where the Video API has a connection issue or times out and we recieve no response or error message

  /* Configuration errors */
  CONFIGURATION = 2000, // The video player is missing one or more required configuration settings.
  ANALYTICS = 2004, // This error happens if the analytics provider configuration is invalid.

  /* Media playback errors */
  MEDIA_ERR_ABORTED = 3001, // The fetching of the associated resource was aborted by the user's request.
  MEDIA_ERR_NETWORK = 3002, // Some kind of network error occurred which prevented the media from being successfully fetched, despite having previously been available.
  MEDIA_ERR_DECODE = 3003, // Despite having previously been determined to be usable, an error occurred while trying to decode the media resource, resulting in an error.
  MEDIA_ERR_SRC_NOT_SUPPORTED = 3004, // The associated resource or media provider object (such as a MediaStream) has been found to be unsuitable.
  MEDIA_ERR_ENCRYPTED = 3005, // The media is encrypted and there are no keys to decrypt it.

  DEFAULT = 9000, // Raised when any error unexpected by the player occurs during initialization.
}
